var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infos"},_vm._l((_vm.data),function(item,index){return _c('NewsItem',{key:index,attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }